import Api from './api'

const ApiInstance = new Api()

export default ApiInstance
